export var defaultDropzoneStyles = { paddingTop: "27px" };
